/** @prettier */
import { delay } from 'redux-saga';

import { PAGE_VISIBILITY_CHANGE } from '@xanadu/ui-shared/modules/application/actions';
import { refreshSubscribedEvents } from '@xanadu/ui-shared/modules/event/actions';

import { all, fork, put, select, take } from 'redux-saga/effects';

/**
 * This is the interval (ms) before the subscribed events can be refreshed
 * @type {Number}
 */
const EVENTS_POLLING = 60000;

function* pollSubscribedEvents() {
  while (true) {
    const visible = yield select((state) => state.getIn(['application', 'visible']));

    if (visible) {
      yield put(refreshSubscribedEvents());
    } else {
      // eslint-disable-next-line no-console
      console.info('Events queued');
      yield take(PAGE_VISIBILITY_CHANGE);
      yield put(refreshSubscribedEvents());
    }

    yield delay(EVENTS_POLLING);
  }
}

export default function* root() {
  yield all([fork(pollSubscribedEvents)]);
}
